<template>
  <div class="relative min-h-screen bg-gradient-to-br from-green-100 via-white to-blue-100 p-4">
    <!-- LOADING OVERLAY -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <!-- SAYFA İÇERİĞİ -->
    <div
        v-show="!loading"
        class="bg-white bg-opacity-90 shadow-xl rounded-2xl p-8 flex flex-col items-center text-center max-w-md w-auto mx-auto mt-20"
    >
      <img
          src="../../assets/images/Payment/payment-success.png"
          class="w-20 h-20 mb-6"
          alt="success"
      />
      <h1 class="text-xl font-semibold text-gray-800 mb-2">
        Ödemeniz başarıyla alındı.
      </h1>

      <h4 class="text-xl font-semibold text-gray-800 mb-2">
        Güncel bakiyeniz:
        <span class="font-semibold text-green-600">{{ $store.state.balanceText }}</span>
      </h4>

      <button type="submit" class="btn btn-success mt-3" @click.prevent="routeOrder">
        Sipariş Ver
      </button>
    </div>
  </div>
</template>

<script>
import ClientService from '../../service/ClientService';
import OrderService from '../../service/OrderService';

export default {
  name: "PaymentSuccess",
  data() {
    return {
      loading: true
    };
  },
  async mounted() {
    await this.getBalance();
    await this.handlePendingOrder();
  },
  methods: {
    async routeOrder() {
      await this.$router.push({ name: 'Order' });
    },
    async getBalance() {
      try {
        const response = await ClientService.getBalance(this.$store.state.clientId);
        this.$store.commit('setBalanceText', response);
      } catch (error) {
        console.error("Bakiye alınırken hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    },
    async handlePendingOrder() {
      const pending = this.$store.state.pendingOrder;
      if (!pending) {
        return;
      }

      const clientId = this.$store.state.clientId;
      const isExpired = !pending.expiresAt || pending.expiresAt < Date.now();
      const isMismatch = pending.clientId !== clientId;

      if (isExpired || isMismatch || !clientId) {
        this.$store.commit('clearPendingOrder');
        return;
      }

      this.loading = true;
      try {
        const response = await OrderService.autoCreate(clientId);
        this.$store.commit('setBalanceText', response.balanceText);
        this.$store.commit('clearPendingOrder');
        this.$notification(this, "Sipariş başarıyla oluşturuldu.");
        await this.$router.push({ name: 'Order' });
      } catch (error) {
        // Global error handler displays the message; just clear the pending flag.
        this.$store.commit('clearPendingOrder');
        this.$alert(this, error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

</style>